import { Locale } from "@redotech/crdb-enums/common/locale";
import * as z from "zod";

export const VOICE_NOTE_MAX_DURATION_MS = 30_000;

export const VOICE_NOTE_MIN_DURATION_MS = 700;

/** How long before the limit the timer switches to a countdown. */
export const VOICE_NOTE_WARNING_WINDOW_MS = 5000;

/** Generous for 30 seconds of Opus or AAC; anything larger isn't a voice note. */
export const VOICE_NOTE_MAX_AUDIO_BYTES = 2 * 1024 * 1024;

export const voiceNoteAudioMimeTypes = [
  "audio/webm",
  "audio/mp4",
  "audio/ogg",
] as const;
export type VoiceNoteAudioMimeType = (typeof voiceNoteAudioMimeTypes)[number];

export const voiceNoteLocaleSchema = z.enum(Locale);

/** Defaults to English so a server that predates the field doesn't fail the client's output parse. */
export const merchantNotesLocaleSchema = voiceNoteLocaleSchema.default(
  Locale.En,
);
